<div class="modal-container">
  <button
    id="modalPreguntasFrecuentes"
    #modalPreguntasFrecuentes
    data-bs-toggle="modal"
    data-bs-target="#modalPreguntasFrecuentesForm"
    hidden="hidden"
    hidden
    aria-hidden="true"
    tabindex="-1">
    Launch
  </button>

  <div
    class="modal fade"
    id="modalPreguntasFrecuentesForm"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle">
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ (isEditar ?'preguntas.editar_pregunta':'preguntas.crear_pregunta') | translate }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"></button>
        </div>

        <div class="modal-body" *ngIf="isEditar; else savePregunta">
          <form
            [formGroup]="formularioPreguntas"
            (ngSubmit)="onGuardarPreguntaEditada()">
            <div class="mb-4">
              <label for="pregunta" class="form-label">
                {{ 'preguntas.pregunta' | translate }}:
              </label>
              <input
                id="pregunta"
                class="form-control"
                formControlName="pregunta" />
            </div>
            <div class="mb-4">
              <label for="pregunta" class="form-label">
                {{ 'preguntas.respuesta' | translate }}:
              </label>
              <quill-editor
                id="respuesta"
                formControlName="respuesta"
                [style]="{ minHeight: '300px' }">
              </quill-editor>
            </div>
            <div class="modal-footer">
              <button
                type="submit"
                data-bs-dismiss="modal"
                [disabled]="formularioPreguntas.invalid"
                class="btn btn-govco fill-btn-govco my-2"
                aria-label="Guardar">
                {{ 'preguntas.guardar' | translate }}
              </button>
              <button
                type="button"
                class="btn btn-govco outline-btn-govco my-2"
                data-bs-dismiss="modal"
                aria-label="Cancelar">
                {{ 'preguntas.cancelar' | translate }}
              </button>
            </div>
          </form>
        </div>
        <ng-template #savePregunta>
          <div class="modal-body">
            <form
              [formGroup]="formularioPreguntasCrear"
              (ngSubmit)="onGuardarPregunta()">
              <div class="mb-4">
                  <label for="entidad" class="form-label"
                    >{{ 'preguntas.categoria' | translate }}:</label
                  >
                  <select
                    id="categoria"
                    class="form-select"
                    formControlName="categoria">
                    <option value="" disabled>
                      {{ 'glosario.seleccione_opcion' | translate }}
                    </option>
                    <option *ngFor="let cat of categoriasKeys" [value]="cat">
                      {{ cat }}
                  </select>
                </div>
              <div class="mb-4">
                <label for="pregunta" class="form-label">
                  {{ 'preguntas.pregunta' | translate }}:
                </label>
                <input
                  id="pregunta"
                  class="form-control"
                  formControlName="pregunta" />
              </div>
              <div class="mb-4">
                <label for="respuesta" class="form-label">
                  {{ 'preguntas.respuesta' | translate }}:
                </label>
                <quill-editor
                  id="respuesta"
                  formControlName="respuesta"
                  [style]="{ minHeight: '300px' }">
                </quill-editor>
              </div>
              <div class="modal-footer">
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  [disabled]="formularioPreguntasCrear.invalid"
                  class="btn btn-govco fill-btn-govco my-2"
                  aria-label="Guardar">
                  {{ 'preguntas.guardar' | translate }}
                </button>
                <button
                  type="button"
                  class="btn btn-govco outline-btn-govco my-2"
                  data-bs-dismiss="modal"
                  aria-label="Cancelar">
                  {{ 'preguntas.cancelar' | translate }}
                </button>
              </div>
            </form>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
